"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPendingClassMetadata = isPendingClassMetadata;
const reflect_metadata_utils_1 = require("@inversifyjs/reflect-metadata-utils");
const pendingClassMetadataCountReflectKey_1 = require("../../reflectMetadata/data/pendingClassMetadataCountReflectKey");
function isPendingClassMetadata(type) {
    const pendingClassMetadataCount = (0, reflect_metadata_utils_1.getOwnReflectMetadata)(type, pendingClassMetadataCountReflectKey_1.pendingClassMetadataCountReflectKey);
    return (pendingClassMetadataCount !== undefined && pendingClassMetadataCount !== 0);
}
//# sourceMappingURL=isPendingClassMetadata.js.map